import classNames from 'classnames';
import { ComponentPropsWithoutRef, FC } from 'react';

import { Flex } from '@servicetitan/anvil2';

export const Content: FC<ComponentPropsWithoutRef<typeof Flex>> = ({
    children,
    className,
    ...props
}) => {
    return (
        <Flex
            {...props}
            className={classNames('a2-bg-strong a2-p-inline-5', className)}
            direction="column"
            style={{ height: '100%' }}
        >
            {children}
        </Flex>
    );
};
